export type TranslatedGenders = Record<TGender | 'all', string>;

export const getDisplayValue = (
	gender: TGender | null,
	translatedGenders: TranslatedGenders
) => {
	if (gender) {
		return translatedGenders[gender];
	}

	return translatedGenders['all'];
};

export const TGENDERS = ['fem', 'mal', 'other', 'femboy'] as const;

export type TGender = (typeof TGENDERS)[number];

export const isTGender = (value: string): value is TGender =>
	TGENDERS.includes(value as TGender);
